const collections = [
  // {
  //   id: 0,
  //   isComplete: false,
  //   isNew: false,
  //   name: "17",
  //   author: [ 
  //     "Herya",
  //   ],
  //   logo: "./images/logo/17.webp",
  //   description: "17171717",
  //   view: "https://17-upcoming.netlify.app",
  //   github: "",
  //   images: [],
  // },
  {
    id: 1,
    isComplete: false,
    isNew: false,
    name: "CodeAnImpact Part",
    author: [ 
      "Heriyanto",
      ", and others.",
    ],
    logo: "./images/logo/w.webp",
    description: "CodeAnImpact part we're work on to build something that can make a positive impact, our goal is to create meaningful products for everyone with memorable experiences. Stay tuned!",
    view: "https://codeanimpact.netlify.app",
    github: "",
    images: [],
  },
  {
    id: 2,
    isComplete: false,
    isNew: false,
    name: "herya",
    author: [ 
      "Heriyanto",
    ],
    logo: "./images/logo/herya-2.webp",
    description: "My personal web app will be available soon. Stay tuned!",
    view: "https://hewrya.netlify.app",
    github: "",
    images: [],
  },
  // {
  //   id: 3,
  //   isComplete: true,
  //   isNew: true,
  //   name: "Heyca 1.7",
  //   author: [ 
  //     "Herya",
  //   ],
  //   logo: "./images/logo/heyca-beta.webp",
  //   // description: "The perfect one will be come soon. \"As different levels, who will laugh at the end\".",
  //   description: "Sesingkat apapun ceritanya tetaplah bermakna meski cerita itu sendiri menyakitkan.",
  //   // description: "",
  //   view: "https://heyca-v1.netlify.app",
  //   github: "https://github.com/herya17/heyca-pwa-resource",
  //   images: [
  //     { id: 0, url: "./images/ui/heyca-beta-1.webp", },
  //     { id: 1, url: "./images/ui/heyca-beta-2.webp", },
  //     { id: 2, url: "./images/ui/heyca-beta-3.webp", },
  //     { id: 3, url: "./images/ui/heyca-beta-4.webp", },
  //   ],
  // },
  {
    id: 4,
    isComplete: true,
    isNew: false,
    name: "Herya Pro",
    author: [ 
      "Heriyanto",
    ],
    logo: "./images/logo/herya.webp",
    description: "Herya Pro is my entire portfolio collection, Herya Pro is built using React by implementing clean and reusable code and ensuring responsive web design using mobile first approach.",
    view: "https://heryapro.netlify.app",
    github: "https://github.com/herya17/herya-project-resource",
    images: [],
  },
  {
    id: 5,
    isComplete: true,
    isNew: false,
    name: "HeyNotes",
    author: [ 
      "Heriyanto",
    ],
    logo: "./images/logo/heynotes.webp",
    description: "This web app has a very different background and has basic questions like why am I making this, why does it have to be like this, how to make it, all of that you can feel after you use it and explore it, so start using it.",
    view: "https://hey-notes.netlify.app",
    github: "https://github.com/hewrya/heynotes-resource",
    images: [
      { id: 0, url: "./images/ui/heyca.webp", },
      { id: 1, url: "./images/ui/heyca-0.webp", },
      { id: 2, url: "./images/ui/heyca-1.webp", },
      { id: 3, url: "./images/ui/heyca-2.webp", },
      { id: 4, url: "./images/ui/heyca-3.webp", },
      { id: 5, url: "./images/ui/heyca-4.webp", },
      { id: 6, url: "./images/ui/heyca-5.webp", },
      { id: 7, url: "./images/ui/heyca-6.webp", },
    ],
  },
  {
    id: 6,
    isComplete: true,
    isNew: false,
    name: "Personal Notes App v2",
    author: [ 
      "Heriyanto",
    ],
    logo: "./images/logo/note.webp",
    description: "Build a single page application using React and validate input with PropTypes and implement path and query parameter to send data via URL.",
    view: "https://personal-notes-app-v2.netlify.app",
    github: "https://github.com/hewrya/personal-notes-app-v2",
    images: [
      { id: 0, url: "./images/ui/notev2-1.webp", },
      { id: 1, url: "./images/ui/notev2-2.webp", },
      { id: 2, url: "./images/ui/notev2-3.webp", },
    ],
  },
  {
    id: 7,
    isComplete: true,
    isNew: false,
    name: "Her App",
    author: [ 
      "Heriyanto",
    ],
    logo: "./images/logo/her.webp",
    description: "Build a restaurant catalog web app with good experience and functionality when accessed on mobile devices by implementing a mobile first approach, accessibility, clean code, PWAs, optimizing web performance, automation testing, and deployment with CI/CD.",
    view: "https://her-app.netlify.app",
    github: "https://github.com/hewrya/her-app-resource",
    images: [
        { id: 0, url: "./images/ui/her-1.webp", },
        { id: 1, url: "./images/ui/her-2.webp", },
        { id: 2, url: "./images/ui/her-3.webp", },
        { id: 3, url: "./images/ui/her-4.webp", },
        { id: 4, url: "./images/ui/her-5.webp", },
        { id: 5, url: "./images/ui/her-6.webp", },
    ],
  },
  {
    id: 8,
    isComplete: true,
    isNew: false,
    name: "Her App Version 2",
    author: [ 
      "Heriyanto",
    ],
    logo: "./images/logo/her.webp",
    description: "In the Her App Version 2, there are additional features by implementing the LINE Front-End Framework (LIFF) with several features such as LINE Login Channel, Send Message, QRCode Scanner, Open Window, and Get Profile.",
    view: "https://her-app-v2.netlify.app",
    github: "https://github.com/hewrya/her-app-v2-resource",
    images: [
        { id: 0, url: "./images/ui/line-1.webp", },
        { id: 1, url: "./images/ui/line-2.webp", },
        { id: 2, url: "./images/ui/line-3.webp", },
        { id: 3, url: "./images/ui/line-4.webp", },
        { id: 4, url: "./images/ui/line-5.webp", },
        { id: 5, url: "./images/ui/her-6.webp"},
    ],
  },
  {
    id: 9,
    isComplete: true,
    isNew: false,
    name: "EPL Unofficial App",
    author: [ 
      "Heriyanto",
    ],
    logo: "./images/logo/epl.webp",
    description: "Build a web-based football information application by implementing PWA properties such as apps shell, offline capabilities, push notifications and installable web apps, so that the website behaves like a native.",
    view: "https://epl-unofficial.netlify.app",
    github: "https://github.com/hewrya/epl-unofficial-resource",
    images: [
        { id: 0, url: "./images/ui/epl-1.webp", },
        { id: 1, url: "./images/ui/epl-2.webp", },
        { id: 2, url: "./images/ui/epl-3.webp", },
        { id: 3, url: "./images/ui/epl-4.webp", },
        { id: 4, url: "./images/ui/epl-5.webp", },
        { id: 5, url: "./images/ui/epl-6.webp", },
    ],
  },
  {
    id: 10,
    isComplete: true,
    isNew: false,
    name: "Personal Notes App",
    author: [ 
      "Heriyanto",
    ],
    logo: "./images/logo/note.webp",
    description: "Build a personal notes web application with React that implements reusable components, stateful components, controlled components, and also has several features such as search notes, archive, and delete.",
    view: "https://notes-v1.netlify.app",
    github: "https://github.com/hewrya/personal-notes-app-resource",
    images: [
        { id: 0, url: "./images/ui/note-1.webp", },
    ],
  },
  {
    id: 11,
    isComplete: true,
    isNew: false,
    name: "MyBooks Apps",
    author: [ 
      "Heriyanto",
    ],
    logo: "./images/logo/mybooks.webp",
    description: "Create interactive web front-end application that have storage feature using web storage.",
    view: "https://mybooks-apps.netlify.app",
    github: "https://github.com/hewrya/mybooks-apps",
    images: [
        { id: 0, url: "./images/ui/mybooks-1.webp", },
    ],
  },
  {
    id: 12,
    isComplete: true,
    isNew: false,
    name: "DSoccer",
    author: [ 
      "Heriyanto",
    ],
    logo: "./images/logo/dsoccer.webp",
    description: "This is the first website I created using semantic HTML and also Flexbox to make it easier to place content. It's unexpected that I have reached this point. If you look at my flashback, when I was at that point I can't imagine what it felt like to be at the point I am now.",
    view: "https://dsoccer.netlify.app",
    github: "https://github.com/hewrya/dsoccer",
    images: [
        { id: 0, url: "./images/ui/dsoccer-1.webp", },
        { id: 1, url: "./images/ui/dsoccer-2.webp", },
        { id: 2, url: "./images/ui/dsoccer-3.webp", },
    ],
  },
];

const getAllCollections = () => {
  return collections;
}

const getNewCollections = () => {
  const newCollections = collections.filter((collection) => collection.isNew);
  return newCollections;
}

const getUpcomingCollections = () => {
  const upcomingCollections = collections.filter((collection) => !collection.isComplete);
  return upcomingCollections;
}

export { getAllCollections, getNewCollections, getUpcomingCollections };

// Ini adalah web pertama yang saya buat menggunakan semantic html dan juga flexbox agar dapat mempermudah dalam peletakan konten. Tidak disangka saya telah mencapai titik ini. Jika melihat kilas balik saya, saya saat berada dititik itu tidak dapat membayangkan bagaimana rasanya berada dititik saya saat ini.
